module.exports = __webpack_public_path__ + "img/tips_icon_fx.87bb7e72.png";